import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import { valuesText } from 'scoreboard/datasets/filters/filter-text'
import formatValue from 'scoreboard/components/format-value'

const REPORT_FILTER_COMPOUND_VALUE_SEPARATOR = ':'

function formatNumericValue(val, dataType, columnType) {
	if (_.isNil(val)) { return val }

	let value = val
	//see ReportSuggestions#scorecardSuggestions.kt on why we're doing this
	let values = val.toString().split(REPORT_FILTER_COMPOUND_VALUE_SEPARATOR)
	if (values.length > 1) {
		value = values[0]
		dataType = values[1]
	}
	return formatValue({
		value,
		dataType: columnType === 'score' ? 'score' : dataType,
		shorten: false,
		omitCurrencySymbol: true // #41250: No specific currency
	})
}

var PrettyRangeNumeric = function(filter, meta, key) {
	let numericOperator = _.camelCase(filter.operator)
	let dateTimeOperator = _.camelCase(filter.dateTimeOperator)

	let messageCode = `report.filter.pretty.range.numeric.${numericOperator}.${dateTimeOperator}`
	const { dataType } = meta

	let filterValues = _.filter(filter.values || [], v => !_.isNil(v))
	const values = filterValues.map(val => {
		return formatNumericValue(val, dataType, key)
	})
	if (filter.operator == 'is-any' || filter.operator == 'is-not-any') {
		return valuesText(`${messageCode}.single`, `${messageCode}.multiple`,
			values, null, true, this.periodLabels(filter))
	} else {
		let args = [messageCode]
		if (filter.operator != 'is-na' && filter.operator != 'is-yes' && filter.operator != 'is-no') {
			args.push(formatNumericValue(filter.value1, dataType, key))
			if (filter.operator == 'between-number') {
				args.push(formatNumericValue(filter.value2, dataType, key))
			}
		}
		return i18n.get.apply(i18n, args.concat(this.periodLabels(filter)))
	}
}

export default PrettyRangeNumeric
export { formatNumericValue }
PrettyRangeNumeric.__filename__ = 'reports/common/filter/pretty-range-numeric.js'
